const utils = require('frontend-controller/lib/utils')

module.exports = {
	extends: [
		'/',
		'templates',
		'artCrm',
		'entity',
		'recordController'
	],

	config: {
		entityContext: 'activity',
		privilegeBase: 'artcrm_activities',
		preventDeletions: true
	},

	methods: {
		submit: function(){
			var self = this;
			var promiseList = [];
			self.find('templates_artCrm_entity_propertiesForm', function(propertiesForm){
				propertiesForm.config.onSubmitDonePanelMessage = false;
				promiseList.push(propertiesForm.submit());
			});
			return utils.promise.resolveAll(self, promiseList)
				.then(function(){ self.submitDone(); })
			;
		},

		submitDone: function(){
			this.callHandler('recordControllerResourcesModified');
			this.removeTab();

			var statusController;
			if((statusController = getComponent('statusController'))){
				statusController.addPanel('status.done.save');
			}
		}
	}
}
